"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var oauth_1 = require('../oauth');
function ensureEnvIsValid() {
    if (!window.cordova) {
        throw new Error('Cannot authenticate via a web browser');
    }
    if (!window.cordova.InAppBrowser) {
        throw new Error('The Apache Cordova InAppBrowser plugin was not found and is required');
    }
    if (window.isAlreadyRunningCordovaInAppBrowserLoginPage) {
        throw new Error('Already launching Login Page');
    }
    window.isAlreadyRunningCordovaInAppBrowserLoginPage = true;
}
var OauthCordova = (function (_super) {
    __extends(OauthCordova, _super);
    function OauthCordova() {
        _super.apply(this, arguments);
        this.defaultWindowOptions = {
            location: 'no',
            clearsessioncache: 'yes',
            clearcache: 'yes'
        };
    }
    OauthCordova.prototype.openDialog = function (url, windowParams, options) {
        if (options === void 0) { options = {}; }
        var params = this.serializeOptions(windowParams);
        return new Promise(function (resolve, reject) {
            try {
                ensureEnvIsValid();
            }
            catch (error) {
                return reject(error);
            }

            let loadingTimer;
            let timeoutTimer;
            let loadStarted = false;
            const browserRef = window.cordova.InAppBrowser.open(url, '_blank', params);

            const clearState = () => {
                if (loadingTimer) clearTimeout(loadingTimer);
                if (timeoutTimer) clearTimeout(timeoutTimer);
                window.isAlreadyRunningCordovaInAppBrowserLoginPage = false;
                browserRef.close();
            };

            const exitListener = () => {
                clearState();
                return reject(new Error("The \"" + options.providerName + "\" sign in flow was canceled"));
            }

            if (windowParams.isAndroid) {
                loadingTimer = setTimeout(function () {
                    browserRef.executeScript({
                        code:
                            "if (!document.body.innerHTML) {" +
                                "  document.write(" +
                                "    '<div style=\"position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);\">" +
                                "      <div style=\"" +
                                "        border: 16px solid #f3f3f3;" +
                                "        border-top: 16px solid #3c4fbc;" +
                                "        border-radius: 50%;" +
                                "        width: 120px;" +
                                "        height: 120px;" +
                                "        animation: spin 2s linear infinite;" +
                                "        \"></div>" +
                                "      <div style=\"" +
                                "        position: fixed;" +
                                "        margin-top: 30px;" +
                                "        top: calc(50% + 70px);" +
                                "        left: 50%;" +
                                "        width: 100%;" +
                                "        padding: 0 10px;" +
                                "        transform: translateX(-50%);" +
                                "        font-size: 40px;" +
                                "        width: max-content;" +
                                "        max-width: calc(100dvw - 40px);" +
                                "        padding: 10px 20px;" +
                                "        background-color: #EBEEFF;" +
                                "        border-radius: 10px;" +
                                "        text-align: center;" +
                                "        color: #3c4fbc;" +
                                "        \">" + windowParams.loadingText + "</div>" +
                                "    </div>" +
                                "    <style>" +
                                "      @keyframes spin {" +
                                "        0% { transform: rotate(0deg); }" +
                                "        100% { transform: rotate(360deg); }" +
                                "      }" +
                                "    </style>'" +
                                ");" +
                            "}"
                    });
                }, 50);
            }
            timeoutTimer = setTimeout(function () {
                if (!loadStarted) {
                    browserRef.removeEventListener('exit', exitListener);
                    clearState();
                    return reject(new Error("Timeout loading page"));
                }
            }, 0.5 * 60 * 1000);

            browserRef.addEventListener('loadstart', function (event) {
                loadStarted = true;
                if (event.url.indexOf(options.resolveOnUri) === 0) {
                    browserRef.removeEventListener('exit', exitListener);
                    clearState();
                    return resolve(event);
                }
            });
            browserRef.addEventListener('loaderror', function () {
                browserRef.removeEventListener('exit', exitListener);
                clearState();
                return reject(new Error("Error loading login page of \"" + options.providerName + "\""));
            });

            return browserRef.addEventListener('exit', exitListener);
        });
    };
    return OauthCordova;
}(oauth_1.Oauth));
exports.OauthCordova = OauthCordova;
